import React from "react";
import {
  Dashboard
} from "../../_metronic/_partials";

export default function DashboardPage() {
  return <Dashboard />;
}
